$(document).ready(function () {
     $('.overview-button').click(function (e) {
        $('.overview-button').removeClass('active_chart_button');
        $(this).addClass('active_chart_button');
    });
});

$(document).ready(function() {
	google.charts.setOnLoadCallback(Default_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Default_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=21&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = { month: 'short', day: 'numeric' };
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);
           
            if (color_dots[20]*1 > color_dots[0]*1) {var chart_color1 = ['#dc2626']} else {var chart_color1 = ['#00d885']}; 
			
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: '4%', 'width': '98%', 'height': '100%'},
				colors: chart_color1,                
               	hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "3",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});

$('#b_5_days').click(function() {
	google.charts.setOnLoadCallback(Week_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Week_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=5&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = { month: 'short', day: 'numeric' };
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);

            if (color_dots[4]*1 > color_dots[0]*1) {var chart_color2 = ['#dc2626']} else {var chart_color2 = ['#00d885']}; 
          
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: '4%', 'width': '98%', 'height': '100%'},
				colors: chart_color2,
				hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "1",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});

$('#b_1_month').click(function() {
	google.charts.setOnLoadCallback(Monthly_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Monthly_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=21&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = { month: 'short', day: 'numeric' };
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);

            if (color_dots[20]*1 > color_dots[0]*1) {var chart_color3 = ['#dc2626']} else {var chart_color3 = ['#00d885']}; 
          
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: '4%', 'width': '98%', 'height': '100%'},
				colors: chart_color3,
				hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "3",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});

$('#b_1_quarter').click(function() {
	google.charts.setOnLoadCallback(Quarterly_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Quarterly_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=63&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = { year: 'numeric', month: 'short' };
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);

            if (color_dots[62]*1 > color_dots[0]*1) {var chart_color4 = ['#dc2626']} else {var chart_color4 = ['#00d885']}; 
			
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: 30, 'width': '98%', 'height': '100%'},
				colors: chart_color4,
				hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "20",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});

$('#b_1_year').click(function() {
	google.charts.setOnLoadCallback(Annual_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Annual_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=261&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = {year: 'numeric', month: 'short' };
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);

            if (color_dots[260]*1 > color_dots[0]*1) {var chart_color5 = ['#dc2626']} else {var chart_color5 = ['#00d885']}; 
          
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: 30, 'width': '98%', 'height': '100%'},
				colors: chart_color5,
				hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "40",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});

$('#b_5_years').click(function() {
	google.charts.setOnLoadCallback(Five_Years_chart);
    var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
    var param;  
    if (metafield.trim() !== "") {param = metafield;} 
    else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
	function Five_Years_chart() {				
		$.getJSON('https://financialmodelingprep.com/api/v3/historical-price-full/'+param+'?timeseries=1305&apikey=3ccf620ce9315de8a4996e601373f716', function(json) {
			var dots = new Array;
            var color_dots = new Array;
			$.each(json, function(){
				$.each(this, function(j, elem){
					var close_price = Number(elem.close);
					var d = new Date(elem.date);
					var options_d = { year: 'numeric', month: 'short'};
					var date_c = d.toLocaleDateString('en-US', options_d);
					if (!isNaN(close_price)) {
					dots.push([date_c, close_price]);
                    color_dots.push([close_price]);
					};
				});
			});
			
			var data = new google.visualization.DataTable();
			data.addColumn('string', 'Date');
			data.addColumn('number', 'Price');
			data.addRows(dots);

            if (color_dots[1304]*1 > color_dots[0]*1) {var chart_color6 = ['#dc2626']} else {var chart_color6 = ['#00d885']}; 
          
			var options = {
				legend: {position: 'none',},
				chartArea:  {top: '10%', bottom: '10%', left: 55, right: 30, 'width': '98%', 'height': '100%'},
				colors: chart_color6,
				hAxis: {
					gridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					direction: "-1",
					slantedText: false,
					showTextEvery: "240",
				},
				vAxis: {
					gridlines: {color: '#e5e7eb'},
                    format:'#,##0.0',
                    minorGridlines: {color: 'transparent'},
                    textStyle: {fontName: 'Arial', color: '#0069b3', fontSize: 14, bold: true, },
					viewWindowMode:'explicit',
				},
				backgroundColor: {fill: 'white', }
			};
			var chart = new google.visualization.AreaChart(document.getElementById('stock_price_chart'));
            function redrawChart() {chart.draw(data, options);}
            redrawChart();
            $(window).resize(function () {redrawChart();});
		}); 	
	}
});